'use es6';

import { List } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestrictedFieldsProblemMessage = ({
  message,
  restrictedFieldLevelProperties = [],
  bulkSelectedReports = []
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: restrictedFieldLevelProperties.length ? /*#__PURE__*/_jsxs("div", {
      children: [message && /*#__PURE__*/_jsx(FormattedMessage, {
        message: message,
        options: {
          count: restrictedFieldLevelProperties.length
        }
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        paddingBlockStart: "200",
        marginBlockEnd: "200",
        wrapChildren: true,
        children: restrictedFieldLevelProperties.map((restrictedField, index) => {
          const property = restrictedField.get('property');
          const propertyName = property.get('label');
          return /*#__PURE__*/_jsx("span", {
            children: propertyName
          }, index);
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reportingActions.common.askAnAccountAdminForAccess'
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: message,
      options: {
        count: bulkSelectedReports.length
      }
    })
  });
};
RestrictedFieldsProblemMessage.propTypes = {
  message: PropTypes.string.isRequired,
  restrictedFieldLevelProperties: PropTypes.array,
  bulkSelectedReports: PropTypes.array
};
export default RestrictedFieldsProblemMessage;